
import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button } from "antd";
import { ApiURL, baseURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";


const Feedback = () => {
  const [page_loader, set_page_loader] = useState(true);
  const [errors, set_errors] = useState({});
  const [ship_id, set_ship_id] = useState(null);
  const [ship_table_list, set_ship_table_list] = useState([]);
  const [feedback, setFeedback] = useState([]);

  /* ---------------- SHIP LIST API ---------------- */
  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
      if (res?.status === true) {
        set_ship_table_list(res?.ships || []);
        FEEDBACK_LIST_API(); // load all feedback initially
      }
    });
  };

  /* ---------------- FEEDBACK LIST API ---------------- */
  const FEEDBACK_LIST_API = (shipId = null) => {
    set_page_loader(true);
    const FORM_DATA = new FormData();

    if (shipId) {
      FORM_DATA.append("ship_id", shipId);
    }

    post(ApiURL.feedback_list_com, FORM_DATA)
      .then((res) => {
        if (res?.status === true) {
          setFeedback(res?.data || []);
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .finally(() => set_page_loader(false));
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  /* ---------------- DESCRIPTION MODAL ---------------- */
  const [descrModal, setDescrModal] = useState({
    visible: false,
    text: "",
  });

  const showDescription = (record) => {
    setDescrModal({ visible: true, text: record.description });
  };

  /* ---------------- ATTACHMENT MODAL ---------------- */
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    url: "",
  });

  // const showAttachment = (path) => {
  //   setAttachmentModal({
  //     visible: true,
  //     url: `${BASE_URL}${path}`,
  //   });
  // };

  const showAttachment = (path) => {
  if (!path) return;

  setAttachmentModal({
    visible: true,
    url: path.startsWith("http") ? path : `${baseURL}${path}`,
  });
};

  /* ---------------- TABLE COLUMNS ---------------- */
  const columns = [
    {
      title: "Feedback ID",
      dataIndex: "feedback_id",
      key: "feedback_id",
      align: "center",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      align: "center",
    },
    {
      title: "Description",
      align: "center",
      key: "description",
      render: (record) => (
        <Button type="link" onClick={() => showDescription(record)}>
          View
        </Button>
      ),
    },
    {
      title: "Attachment",
      align: "center",
      render: (record) =>
        record?.attachment ? (
          <Button
            type="link"
            onClick={() => showAttachment(record.attachment)}
          >
            View
          </Button>
        ) : (
          "—"
        ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => formatDate(text),
    },
    {
      title: "Ship Name",
      dataIndex: "ship_name",
      key: "ship_name",
      align: "center",
    },
  ];

  return (
    <div>
      {/* ---------------- Ship Selection ---------------- */}
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>

          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            allowClear
            onChange={(value) => {
              set_ship_id(value);
              FEEDBACK_LIST_API(value);
            }}
          >
            {ship_table_list?.map((ship) =>
              !ship.soft_delete ? (
                <Select.Option key={ship.id} value={ship.id}>
                  {ship.vessel_name}
                </Select.Option>
              ) : null
            )}
          </Select>

          {errors?.ship_id && (
            <span style={{ color: "red" }}>{errors.ship_id}</span>
          )}
        </div>
      </div>

      {/* ---------------- Page Title ---------------- */}
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6">
          <h3>Feedback List</h3>
        </div>
      </div>

      {/* ---------------- Table ---------------- */}
      <Table
        bordered
        columns={columns}
        dataSource={feedback}
        loading={page_loader}
        pagination={{ pageSize: 10 }}
        rowKey="id"
        className="custom-table"
      />

      {/* ---------------- Description Modal ---------------- */}
      <Modal
        title="Description"
        open={descrModal.visible}
        footer={null}
        onCancel={() => setDescrModal({ visible: false, text: "" })}
      >
        <p>{descrModal.text}</p>
      </Modal>

      {/* ---------------- Attachment Modal ---------------- */}
      <Modal
        title="Attachment Preview"
        open={attachmentModal.visible}
        footer={null}
        width={700}
        onCancel={() =>
          setAttachmentModal({ visible: false, url: "" })
        }
      >
        <img
          src={attachmentModal.url}
          alt="Attachment"
          style={{ width: "100%", borderRadius: "6px" }}
        />
      </Modal>
    </div>
  );
};

export default Feedback;
